import React from 'react';

const SectionContainer = ({ title, subtitle, children }) => {
  return (
    <div className="f22-section">
      <div className="f22-section-header">
        <div className="f22-section-header-left">
          <h3 className="f22-section-title">{title}</h3>
        </div>
        {subtitle && <span className="f22-section-subtitle">{subtitle}</span>}
      </div>
      <div className="f22-section-body">{children}</div>
    </div>
  );
};

export default SectionContainer;
